import React from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames'
import style from './text.css';

export default class Text extends React.Component {
  
  render() {
    
    const clazz = classNames( style.text, style[this.props.type] );
    return ( 
      <div className={clazz}>
        {this.props.text}
        {this.props.children}
      </div>
    )
  }
}
